// extracted by mini-css-extract-plugin
export default {"wrapper":"app-url-listener_wrapper__NPG+o"};